
export enum IndicatorStatuses
{
    FullyFunctional = 1,
    Warning = 2,
    Critical = 3,
    SystemFailure = 4,
}
